export const TypesDescarregaGate = {
    DESCARREGAGATE: "DESCARREGAGATE",
    RESETDESCARREGAGATE: "RESETDESCARREGAGATE",
    EMPILHADEIRADESCARREGAGATE: "EMPILHADEIRADESCARREGAGATE",
    LOCALCARREGAMENTODESCARREGAGATE: "LOCALCARREGAMENTODESCARREGAGATE"
}

const INITIAL = {
    programacaoId: 0,
    gateDetalhe: [],
    empilhadeiraDescarregaGate: -1,
    localCarregamentoDescarregaGate: -1
}

export default function descarregaGateReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesDescarregaGate.DESCARREGAGATE:
            return {
                ...state,
                programacaoId: action.payload.gateId
            };
        case TypesDescarregaGate.EMPILHADEIRADESCARREGAGATE:
            return {
                ...state,
                empilhadeiraDescarregaGate: action.payload.empilhadeiraDescarregaGate
            };
        case TypesDescarregaGate.LOCALCARREGAMENTODESCARREGAGATE:
            return {
                ...state,
                localCarregamentoDescarregaGate: action.payload.localCarregamentoDescarregaGate
            };
        case TypesDescarregaGate.RESETDESCARREGAGATE:
            return INITIAL;
        default:
            return state;
    }
}

export const DescarregaGateActions = {
    descarregaGate,
    resetStateDescarregaGate,
    setEmpilhadeiraDescarregaGate,
    setLocalCarregamentoDescarregaGate
}

function descarregaGate(pgateId) {

    return {
        type: TypesDescarregaGate.DESCARREGAGATE,
        payload: { gateId: pgateId }
    }
}

function setEmpilhadeiraDescarregaGate(emp) {

    return {
        type: TypesDescarregaGate.EMPILHADEIRADESCARREGAGATE,
        payload: { empilhadeiraDescarregaGate: emp }
    }
}

function setLocalCarregamentoDescarregaGate(local) {

    return {
        type: TypesDescarregaGate.LOCALCARREGAMENTODESCARREGAGATE,
        payload: { localCarregamentoDescarregaGate: local }
    }
}

function resetStateDescarregaGate() {
    return { type: "RESETDESCARREGAGATE" }
}